import axios from "axios";
import { appConfig } from "../environment/environments";

const token = localStorage.getItem("msal.idtoken");

axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

export const getProjects = () => {
  return axios({
    method: "GET",
    url: `${appConfig.api.translationApi}projects`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const gettranslationForModel = (id, transKey) =>{
    return axios({
        method: "GET",
        url:  `${appConfig.api.translationApi}translations/getAllFromLanguageID/${id}/${transKey}`,
        headers: { Authorization: `Bearer ${token}` },
    });
}